import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import Marquee from "../components/Marquee";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { SERVICES, whatsappLink } from "../data/content";

export default function Services() {
  return (
    <>
      <PageHeader
        testid="services-page-header"
        overline="Services"
        title={["Everything a room needs,", "under one roof."]}
        intro="From a single bespoke kitchen to an entire villa, our services scale to your site — always design-led, always itemised, always executed by our own teams."
      />

      <section className="container-lux pb-24" data-testid="services-list">
        <Stagger className="space-y-20 lg:space-y-28">
          {SERVICES.map((s, i) => (
            <StaggerItem key={s.num}>
              <div
                className={`grid gap-10 lg:grid-cols-12 items-center ${
                  i % 2 === 1 ? "" : ""
                }`}
              >
                <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                  <div className="relative overflow-hidden group aspect-[4/3]">
                    <img
                      src={s.image}
                      alt={s.title}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-[1.3s] ease-luxe group-hover:scale-[1.05]"
                    />
                    <span className="absolute top-4 left-4 bg-ivory/90 px-3 py-1.5 text-[11px] font-mono tracking-[0.2em] text-bronze">
                      {s.num}
                    </span>
                  </div>
                </div>
                <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                  <h2 className="font-serif font-light text-3xl sm:text-4xl text-ink">
                    {s.title}
                  </h2>
                  <p className="mt-5 text-[15px] font-light leading-relaxed text-stone-warm">
                    {s.desc}
                  </p>
                  <ul className="mt-7 space-y-3">
                    {s.points.map((pt) => (
                      <li key={pt} className="flex items-center gap-3 text-sm text-ink/80">
                        <span className="h-1.5 w-1.5 rotate-45 bg-gold shrink-0" aria-hidden="true" />
                        {pt}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <Marquee />

      <section className="container-lux py-24" data-testid="services-cta">
        <Reveal className="max-w-2xl mx-auto text-center">
          <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl text-ink">
            Not sure where to <span className="italic text-bronze">begin?</span>
          </h2>
          <p className="mt-5 text-[15px] font-light leading-relaxed text-stone-warm">
            Start with a consultation — a measured visit, a candid budget
            conversation and a written scope. No obligation.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-4">
            <Link to="/contact" data-testid="services-cta-consult" className="btn-bronze">
              Book a Consultation
            </Link>
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="services-cta-whatsapp"
              className="btn-outline"
            >
              Ask on WhatsApp
            </a>
          </div>
        </Reveal>
      </section>
    </>
  );
}
